// extracted by mini-css-extract-plugin
export var text = "_a4-0";